import { CSSProperties, MouseEvent, PropsWithChildren } from 'react';

import { PropsWithClassName } from '../types/index';

import { cn } from '@/utils';

type Props = PropsWithClassName<
  PropsWithChildren<{
    title?: string;
    classNames?: string;
    style?: CSSProperties;
    handleClick?: (event: MouseEvent<HTMLDivElement>) => void;
  }>
>;

export const Card = (props: Props) => {
  const { title, children, className, handleClick, style } = props;

  return (
    <div
      className={cn(
        'bg-gdt-gray-7 px-[4.4rem] rounded-xl w-[32rem] pt-[3.88rem] pb-[3rem]',
        className
      )}
      style={style}
      onClick={handleClick}
    >
      {title && <h6 className="text-lg text-center font-bold">{title}</h6>}
      {children}
    </div>
  );
};
